var map = {
	"./bg_color.svg": 6033,
	"./bright_contrast.svg": 94822,
	"./contrast.svg": 79923,
	"./cursorBlack.svg": 36518,
	"./cursorWhite.svg": 55866,
	"./dark_contrast.svg": 60077,
	"./focus_window.svg": 62091,
	"./fontSize.svg": 22682,
	"./height_saturation.svg": 82671,
	"./highlight_headers.svg": 4447,
	"./highlight_link.svg": 84029,
	"./low_saturation.svg": 70504,
	"./monochrome.svg": 15233,
	"./spacing.svg": 67409,
	"./text_color.svg": 72813,
	"./zoom.svg": 32342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38123;